import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IDrink, ILiquor } from '../models/interfaces';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';

const numberRequiredValidator = Validators.compose([
	Validators.required,
	Validators.pattern('^[0-9]+$'),
]);

const abvValidator = Validators.compose([
	Validators.pattern('^[0-9]+(\.[0-9]+)?$'),
	Validators.min(0),
	Validators.max(100)
]);

const amountValidator = Validators.compose([
	numberRequiredValidator,
	Validators.min(1)
]);


// Concrete implementation of IDrink
// TODO Move this to a separate file
class Drink implements IDrink {
	name: string = '';
	contents: ILiquor[] = [];

	constructor() {}

	getAbv(): number {
		return (this.getAlcoholGrams()/this.getMl()) * 100;
	}

	getMl(): number {
		return this.contents.reduce<number>(
			(p, c) => p + c.amount, 0)
	}

	getStandardDrinks(): number {
		return this.getAlcoholGrams() / 12.5;
	}

	getAlcoholGrams(): number {
		return this.contents.reduce<number>(
			(p, c) => p + (c.amount * (c.abv/100)), 0)
	}

	addLiquor(liquor: ILiquor) {
		return this.contents.push(liquor);
	}

	removeLiquorIdx(idx: number) {
		this.contents.splice(idx, 1);
	}
}

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
	@ViewChild('drinkInfo') drinkInfoAnchor: ElementRef;
	@ViewChild('drinkContents') drinkContentsAnchor: ElementRef;
	@ViewChild('ingredientInput') ingredientAnchor: ElementRef;

	title = 'ABV: Doctors Finest';

	drink: IDrink;

	// Form Groups / Controls
	addDrinkForm: FormGroup;
	ingredient: AbstractControl;
	abv: AbstractControl;
	amount: AbstractControl;

	constructor(fb: FormBuilder) {
		this.drink = new Drink();

		// Create a drink form
		this.addDrinkForm = fb.group({
			'ingredient': ['', Validators.required],
			'abv': ['', abvValidator],
			'amount': ['', amountValidator],
		});

		this.ingredient = this.addDrinkForm.controls['ingredient'];
		this.abv = this.addDrinkForm.controls['abv'];
		this.amount = this.addDrinkForm.controls['amount'];
	}

	// Remove a liquor by Idx
	removeLiquorIdx(idx: number) {
		this.drink.removeLiquorIdx(idx);
	}

	onDrinkSubmit(val: any) {
		if (!this.addDrinkForm.valid) return;

		let l: ILiquor = {
			name: this.ingredient.value,
			abv: Number(val.abv),
			amount: Number(val.amount)
		}

		this.drink.addLiquor(l);

		this.addDrinkForm.reset();
	}

	ngOnInit(): void {}

	pageGoto(name: string) {
		console.log('goto', name);
		if (name === 'contents') {
			this.drinkContentsAnchor.nativeElement.scrollIntoView({behaviour: 'smooth'});
			this.ingredientAnchor.nativeElement.focus();
		} else if (name === 'stats') {
			this.drinkInfoAnchor.nativeElement.scrollIntoView({behaviour: 'smooth'});
		}
	}

	getRounded(value: number) {
		return Math.round(value * 10) / 10;
	}
}
